// autogenerated by channel_search/generate.py -- do not edit
import { UiVariablesPb } from "@skydio/pbtypes/pbtypes/gen/skills/ui_variables_pb";
export { UiVariablesPb };

export const PHONE_UI_VARIABLES_PB = {
  channel: "PHONE_UI_VARIABLES_PB",
  channelId: 5678,
  type: UiVariablesPb.deserializeBinary
};
